function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.654 12.388h.936s.282-.031.426-.187c.133-.142.129-.41.129-.41s-.019-1.255.564-1.44c.574-.182 1.311 1.213 2.093 1.749.59.406 1.04.317 1.04.317l2.089-.03s1.093-.067.574-.926c-.042-.07-.301-.636-1.553-1.797-1.31-1.216-1.135-1.02.443-3.123.962-1.28 1.346-2.063 1.226-2.398-.115-.319-.822-.234-.822-.234l-2.352.014s-.174-.024-.304.054c-.126.076-.208.252-.208.252s-.372.991-.868 1.834C10.019 7.843 9.6 7.936 9.429 7.826c-.398-.258-.299-1.034-.299-1.586 0-1.724.262-2.443-.509-2.629-.256-.062-.444-.102-1.098-.109-.839-.009-1.55.003-1.952.2-.267.13-.474.423-.348.44.155.02.508.094.694.349.241.328.233 1.064.233 1.064s.138 2.03-.324 2.281c-.317.173-.752-.18-1.686-1.793-.478-.827-.84-1.74-.84-1.74s-.069-.171-.193-.263a.975.975 0 00-.362-.146L.51 3.91s-.336.01-.459.155c-.11.13-.009.398-.009.398s1.75 4.095 3.732 6.158c1.817 1.892 3.88 1.768 3.88 1.768z",
  fill: "#E1E8F2"
});

var SvgVkWhite = function SvgVkWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref);
};

export default SvgVkWhite;